import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Input, Popover, Button } from 'antd';

const FormItem = Form.Item;

export type FormValues = {
  pin: string;
};

const LogoutButton = styled(Button)`
  display: block !important;
  margin: 8px auto 0 !important;
  padding: 0 !important;
  height: auto !important;
  font-size: 13px !important;
  color: ${(props) => props.theme.gray} !important;
`;

interface Props {
  email: string;
  checking?: boolean;
  onPinEnter: (values: { email: string; pin: string }) => void;
  onLogout: () => void;
  error: boolean;
}

const PinForm: React.FC<Props> = ({
  email,
  onPinEnter,
  onLogout,
  checking,
  error,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm<FormValues>();
  useEffect(() => {
    if (error) {
      form.resetFields();
    }
  }, [form, error]);
  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={({ pin }) => {
        if (pin.length === 4) {
          onPinEnter({ email, pin });
        }
      }}
      css="margin-bottom: 36px;text-align: center;"
    >
      <Popover
        content={intl.formatMessage({
          defaultMessage: 'PIN of the owner when logging into the POS',
        })}
        placement="bottom"
      >
        <FormItem
          name="pin"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                defaultMessage: 'No PIN entered. Please enter your PIN.',
              }),
            },
          ]}
        >
          <Input.OTP
            length={4}
            mask="*"
            autoFocus
            disabled={checking}
            styles={{ input: { width: 32, height: 32, padding: '16px' } }}
          />
        </FormItem>
      </Popover>
      <LogoutButton type="link" onClick={onLogout}>
        <FormattedMessage defaultMessage="Logout" />
      </LogoutButton>
    </Form>
  );
};

export default PinForm;
